import { IResponse, IResponseList } from '@/types/common';
import {
  ICreateCogevoStampImageRequest,
  IUpdateCogevoStampImageRequest,
} from '@/types/request/cogevoStampImage';
import {
  IGetDetailCogevoStampImageResponse,
  IGetListCogevoStampImageResponse,
} from '@/types/response/cogevoStampImage';
import axiosClient from '../axiosClient';
import { ENDPOINT } from '../endpoint';

class CogevoStampImage {
  getList = (): Promise<IResponseList<IGetListCogevoStampImageResponse>> =>
    axiosClient.get(ENDPOINT.COGEVO_STAMP_IMAGE.GET_LIST);

  getDetail = (
    id: number,
  ): Promise<IResponse<IGetDetailCogevoStampImageResponse>> =>
    axiosClient.get(
      ENDPOINT.COGEVO_STAMP_IMAGE.GET_DETAIL.replace(':id', String(id)),
    );

  create = (
    body: ICreateCogevoStampImageRequest,
  ): Promise<IResponse<IGetDetailCogevoStampImageResponse>> =>
    axiosClient.post(ENDPOINT.COGEVO_STAMP_IMAGE.CREATE, body);

  update = (
    body: IUpdateCogevoStampImageRequest,
    id: number,
  ): Promise<IResponse<IGetDetailCogevoStampImageResponse>> =>
    axiosClient.put(
      ENDPOINT.COGEVO_STAMP_IMAGE.UPDATE.replace(':id', String(id)),
      body,
    );

  delete = (id: number) =>
    axiosClient.delete(
      ENDPOINT.COGEVO_STAMP_IMAGE.DELETE.replace(':id', String(id)),
    );
}

export const CogevoStampImageService = new CogevoStampImage();
